import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';
import { saveBlobResponse } from '../utils/download';

const BASE_URL = `${API_BASE_URL}/company-documents/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

// No Content-Type: the browser sets multipart/form-data itself, and only it
// knows the boundary. Setting it by hand makes the backend see no file at all.
const getUploadHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`
});

const documentService = {
  listDocuments: () => axios.get(BASE_URL, { headers: getHeaders() }),

  replaceDocument: (slug, file) => {
    const body = new FormData();
    body.append('file', file);

    return axios.put(`${BASE_URL}${slug}/`, body, { headers: getUploadHeaders() });
  },

  downloadDocument: (slug) =>
    axios
      .get(`${BASE_URL}${slug}/download/`, {
        headers: getHeaders(),
        responseType: 'blob'
      })
      .then((response) => saveBlobResponse(response, `${slug}.pdf`)),

  downloadZip: (slugs) =>
    axios
      .get(`${BASE_URL}download-zip/?slugs=${slugs.join(',')}`, {
        headers: getHeaders(),
        responseType: 'blob'
      })
      .then((response) => saveBlobResponse(response, 'brintter-documentos.zip'))
};

export default documentService;
